import styled from "styled-components";

export const PageHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const PageTitle = styled.h2`
  font-size: 16px;
  font-weight: 700;
  color: #111;
`;

export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
`;

export const SearchWrap = styled.div`
  position: relative;
  flex: 1;
  max-width: 320px;
`;

export const SearchIcon = styled.span`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 14px;
  color: #bbb;
  pointer-events: none;
`;

export const SearchInput = styled.input`
  width: 100%;
  height: 40px;
  padding: 0 12px 0 36px;
  border: 1.5px solid #e8e8e8;
  border-radius: 10px;
  font-size: 14px;
  color: #111;
  background-color: #fff;
  transition: border-color 0.15s;

  &::placeholder { color: #bbb; }
  &:focus { outline: none; border-color: #1fbc70; }
`;

export const TypeSelect = styled.select`
  height: 40px;
  padding: 0 12px;
  border: 1.5px solid #e8e8e8;
  border-radius: 10px;
  font-size: 14px;
  color: #111;
  background-color: #fff;
  cursor: pointer;
  transition: border-color 0.15s;

  &:focus { outline: none; border-color: #1fbc70; }
`;

export const CountText = styled.p`
  font-size: 13px;
  color: #aaa;
  margin-left: auto;
`;

export const Card = styled.div`
  background-color: #fff;
  border-radius: 16px;
  border: 1px solid #eaeaea;
  overflow: hidden;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const Thead = styled.thead`
  background-color: #fafafa;
  border-bottom: 1px solid #f0f0f0;
`;

export const Th = styled.th<{ width?: string }>`
  padding: 12px 20px;
  font-size: 12px;
  font-weight: 600;
  color: #888;
  text-align: left;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
  width: ${({ width }) => width ?? "auto"};
`;

export const Tbody = styled.tbody``;

export const Tr = styled.tr`
  border-bottom: 1px solid #f5f5f5;
  cursor: pointer;
  &:last-child { border-bottom: none; }
  &:hover { background-color: #fafff9; }
`;

export const Td = styled.td`
  padding: 14px 20px;
  font-size: 14px;
  color: #333;
  vertical-align: middle;
`;

export const IndexCell = styled.span`
  font-size: 13px;
  color: #bbb;
  font-weight: 500;
`;

export const NoticeTitle = styled.span`
  font-weight: 600;
  color: #111;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 480px;
  display: block;
`;

export const DateText = styled.span`
  font-size: 13px;
  color: #aaa;
  white-space: nowrap;
`;

export const TypeBadge = styled.span<{ type?: string }>`
  display: inline-block;
  padding: 2px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  background-color: ${({ type }) => (type === "IMPORTANT" ? "#fff0f0" : "#f0fdf7")};
  color: ${({ type }) => (type === "IMPORTANT" ? "#fc324a" : "#1fbc70")};
  border: 1px solid ${({ type }) => (type === "IMPORTANT" ? "#ffd0d5" : "#d0f0e0")};
  white-space: nowrap;
`;

export const EmptyCell = styled.td`
  padding: 60px 20px;
  text-align: center;
  color: #bbb;
  font-size: 14px;
`;

/* ── 페이지네이션 ── */

export const Pagination = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 20px;
  border-top: 1px solid #f0f0f0;
`;

export const PageButton = styled.button<{ active?: boolean }>`
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  border-radius: 8px;
  border: 1px solid ${({ active }) => (active ? "#1fbc70" : "#e8e8e8")};
  background-color: ${({ active }) => (active ? "#1fbc70" : "#fff")};
  color: ${({ active }) => (active ? "#fff" : "#555")};
  font-size: 13px;
  font-weight: ${({ active }) => (active ? 700 : 400)};
  cursor: pointer;
  transition: background-color 0.15s, border-color 0.15s;

  &:hover:not(:disabled) {
    background-color: ${({ active }) => (active ? "#18a860" : "#f5f5f5")};
  }
  &:disabled { opacity: 0.4; cursor: not-allowed; }
`;
